import { compose } from 'redux';
import { connect } from 'react-redux';
import MicPermissionsCard from './MicPermissionsCard';
import { getTrcInstruction, getTrcCaption } from '../../../troConstants';
import AvatarView from '../../../../common/avatar/avatarView';
import withAvatar from '../../../../common/avatar/withAvatar';
import { narrateReset, stopAudio } from '../../../../common/audio/audioActions';
import { unmountScreen } from '../../../../common/screen/screenActions';
import { narrateScreen } from '../../../trcActions';
import selectors from '../../../../rootSelectors';
import {
    setRecordingStream,
    setPermissionsError,
} from '../../../../common/recording/recordingActions';

const instructionsKey = 'trcMicPermission';

const mapStateToProps = state => ({
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isExternalURLSourcePresent: selectors.getExternalURLSourceStatus(state),
    arLanguage: selectors.getArLanguage(state),
});

const mapDispatchToProps = dispatch => ({
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(narrateReset());
        dispatch(unmountScreen());
    },
    narrateScreen: (isExternalURLSourcePresent, arLanguage) => {
        const instruction = getTrcInstruction(
            isExternalURLSourcePresent,
            instructionsKey,
            arLanguage,
        );
        const caption = getTrcCaption(isExternalURLSourcePresent, instructionsKey, arLanguage);
        return dispatch(narrateScreen(instruction, caption));
    },
    setRecordingStream: recordingStream => dispatch(setRecordingStream(recordingStream)),
    onPermissionsError: permissionsError => {
        dispatch(setPermissionsError(permissionsError));
    },
});

const avatarMapStateToProps = state => ({
    position: AvatarView.Position.MIDDLE_LEFT,
    instructions: getTrcInstruction(
        selectors.getExternalURLSourceStatus(state),
        instructionsKey,
        selectors.getArLanguage(state),
    ),
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(MicPermissionsCard);
